import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { buildProductTitle, checkAndUpdateOldCartId, destructureAndGetCurrentCartItemsList, errorHandlingEpharmacy, getImageUrlWithSize} from '@common/Utility/common-utils';
import {
  ONLINE_PHARMACY_ROUTE,
  FLAGSMITH_KEYS,
  LOCALSTORAGE_KEYS, 
  CART_TYPES,
  MY_CART_ROUTE
} from '@common/Utility/constants';
import { addItemsToCart, updateUserCartData } from 'aster-foundation/core/epharmacy/Cart/redux/actions';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { useRouter } from 'next/router';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { flagsmith } from '@common/Lib/Flagsmith';
import AddToCart from '../Cart/AddToCart';
import { CartFillerMiniCartStyled } from './CartFillerMiniCartStyled';
import { IC_EXPRESS_NEW, IC_FLASH,IC_EXPRESS_SHEDULED, UNION_LOGO, IC_UNION_WHITE } from '../../../public/images';
import { dataLayerSendEvent,getProductItemObjectAddToCartEvent, getProductItemObjectEventFillersSelect } from 'Epharmacy/EpharmacyAnalytics';
import { setProductItemQtyMultiple } from 'Epharmacy/ProductDetails/redux/reducer';
import { setTotalQtyData } from './redux/reducer';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getCurrency } from '@common/Constants/analytics';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';

const CartFillerMiniCart = (item) => {
  const flashDeliveryFlag = flagsmith.getValue(FLAGSMITH_KEYS.FLASH_DELIVERY, { json: true });
  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;
  const [filleraddedtocart, setFilleraddedtocart] = useState(false);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const cartDataInitial = useSelector((state) => state?.epharmacy?.getCartDetails?.data);
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo)
  const sku = item?.item?.sku;
  const dispatch = useDispatch();
  const router = useRouter();
  const generateURL = useNavigationURL();
  const isMyCartPage = router?.pathname?.indexOf(MY_CART_ROUTE) > -1;
  const ae_web_cartfillersConfig = flagsmith.getValue('ae_web_cartfillers', { json: true });
  const showFillerTitle = ae_web_cartfillersConfig?.showTitle;
  const showEllipsisInTitle = ae_web_cartfillersConfig?.showEllipsisInTitle;

  const productItem = cartDataInitial?.body?.delivery_groups;
  const flashItems = productItem?.filter((ele) => ele.product?.isFlash && flashDeliveryFlag?.enabled);
  const expressItems = productItem?.filter((ele) => ele.product?.express && (!flashDeliveryFlag?.enabled || !ele.product?.isFlash));
  const standardItems = productItem?.filter((ele) => !ele.product?.express && (!flashDeliveryFlag?.enabled  || !ele.product?.isFlash));

const handleAddToCart = (sku) => {
  const filteredCartFillers = item?.cartfillers?.filter((cartFiller) => cartFiller.sku === sku) || [];
  if (filteredCartFillers?.length > 0) {
    dataLayerSendEvent('add_to_cart', {
      ecommerce: {
        items: [{
          ...getProductItemObjectAddToCartEvent(filteredCartFillers[0]),
          index: (parseInt(filteredCartFillers[0]?.index) || item?.index) + 1,
          quantity: 1,
        }],
      },
      section_name: item?.sectionName,
      screen_name: item?.screenName,
      page_type: item?.pageType,
      page_id: item?.pageId,
      bundle_name: null,
      total_discount: 0,
      currency: 'AED',
      delivery_promise: filteredCartFillers[0]?.deliverBy || null,
      availability: filteredCartFillers[0]?.outOfStock ? 'out of stock' : 'in stock',
      express_availability: filteredCartFillers[0]?.express || false,
      value: parseFloat(filteredCartFillers[0]?.specialPrice) || parseFloat(filteredCartFillers[0]?.price),
      location: item?.location || null,
      promotion_name: null,
      promotion_value_tag: null,
      bundle_deal_availability: filteredCartFillers[0]?.isBundled || false,
      referrer_page: item?.referrer_page,
      myaster_category: 'epharmacy',
    });

    sendEventToSmartLook('add_to_cart');
    setFilleraddedtocart(false);
  }
};

  const addToCartApiCallForV2 = () => {
    const params = {
      cartType: CART_TYPES.AE,
      items: [                                                                                                                              
        {
          sku,
          "quantity": 1
        }
      ]
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    if (userZoneData) {
      params.zones = userZoneData;
    } 
    if(isMyCartPage) {
      params.showCart = true;
    }
    dispatch(addItemsToCart({
      params,
      onSuccess: (res) => {
        handleAddToCart(sku);
        // TODO: Keeping this for reference. Will remove after testing
        // EventEmitter.dispatch('fetchCartDetails', { cartIdParam: cartDataInitial?.body?.cart_id });
        if (res?.message) {
          toast.warning(res?.message);
        } else {
          dispatch(updateUserCartData({body: res}));
          localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
          checkAndUpdateOldCartId(res?.cart_id);
          setFilleraddedtocart(true);
          if (res?.delivery_groups) {
            dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(res)));
          }
          dispatch(setTotalQtyData(res?.total_quantity));
        }
      },
      onFailure: (err) => {
        errorHandlingEpharmacy(err, true);
      },
    }))
  };

  const renderTitle = (content) => {
    const charPerRow = item?.isInRightSideBar ? 18 : 17;
    return buildProductTitle({ content, showEllipsisInTitle, charPerRow });
  };

  return (
    <>
      <CartFillerMiniCartStyled isPromotionCart={item?.isPromotionCart} showFillerTitle={showFillerTitle} title={item?.title}>
        <div className="cart-filler-mini-cart">
          <div className="image-wrapper">
            <div className={item?.isPromotionCart ? 'mini-cart-image-promotion' : 'mini-cart-image'}>
              {flashDeliveryFlag?.enabled && !!item?.item?.isFlash && (
                <div className="flash-badge">
                  <div className="express-badge">
                    <Image
                      src={IC_FLASH}
                      alt="IC_EXPRESS_NEW"
                      width={item?.isPromotionCart ? 67 : 36}
                      height={item?.isPromotionCart ? 20 : 20}
                    />
                  </div>
                </div>
              )}

              {(!!item?.item?.express || !!item?.item?.isScheduled || !!item?.item?.express_bool) && !item?.item?.isFlash && (
                <div className="product-badge">
                  <div className="express-badge">
                    <Image
                      src={(item?.isSheduledExpress && item?.item?.isScheduled) ? IC_EXPRESS_SHEDULED : IC_EXPRESS_NEW}
                      alt="IC_EXPRESS_NEW"
                      width={item?.isPromotionCart ? 67 : 36}
                      height={item?.isPromotionCart ? 20 : 20}
                    />
                  </div>
                </div>
              )}

              {flashDeliveryFlag?.enabled && flashItems?.length > 0 && (
                <div>
                  {flashItems
                    .filter((item) => item.sku === sku && item.qty > 0)
                    .map((item) => {
                      return (
                        <div key={item.id} className="click-count">
                          <div className="click-text">{item.qty}</div>
                        </div>
                      );
                    })}
                </div>
              )}

              {expressItems?.length > 0 && (
                <div>
                  {expressItems
                    .filter((item) => item.sku === sku && item.qty > 0)
                    .map((item) => {
                      return (
                        <div key={item.id} className="click-count">
                          <div className="click-text">{item.qty}</div>
                        </div>
                      );
                    })}
                </div>
              )}
              {standardItems?.length > 0 && (
                <div>
                  {standardItems
                    .filter((item) => item.sku === sku && item.qty > 0)
                    .map((item) => {
                      return (
                        <div key={item.id} className="click-count">
                          <div className="click-text">{item.qty}</div>
                        </div>
                      );
                    })}
                </div>
              )}
              <img
                src={getImageUrlWithSize(item?.item?.imageUrl || item?.item?.small_image, item?.isPromotionCart ? 116 : 68, item?.isPromotionCart ? 100 : 68)}
                alt={item?.name}
                width={item?.isPromotionCart ? 116 : 70}
                height={item?.isPromotionCart ? 100 : 68}
                onClick={() =>{
                  router.push({
                    pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${item?.item?.productUrl}`)
                  });
                  const filteredIndices = item?.cartFillers
                    ?.map((cartFiller, index) => ({ cartFiller, index }))
                    ?.filter(({ cartFiller }) => sku?.includes(cartFiller?.sku))
                    ?.map(({ index }) => index); 
                  dataLayerSendEvent('select_item', {
                    ecommerce: {
                      items: item ? [{ ...getProductItemObjectEventFillersSelect(item?.item), index: (parseInt(filteredIndices) || item?.index) +1 }] : []
                    },
                    section_name: item?.sectionName,
                    screen_name: item?.screenName,
                    page_type: item?.pageType,
                    page_id: item?.pageId,
                    availability: item?.item?.outOfStock  ? "out of stock" : "in stock",
                    express_availability:item?.item?.express ? 'true' : 'false',
                    delivery_promise: item?.item?.deliverBy ? item?.item?.deliverBy : null,
                    promotion_name:null,
                    promotion_value_tag: null,
                    location:item?.location ? item?.location : null,
                    referrer_page: item?.referrer_page,
                    myaster_category: 'epharmacy',
                    currency: getCurrency(getDataFromCookie('regionCode')),
                  });
                  sendEventToSmartLook('select_item');
                  item?.setShowUpselling(false);
                }}
              />
              {!item?.isPromotionCart && (
                <div
                  className={item?.item?.inStock ? 'union-logo-container' : 'union-logo-container-disabled'}
                  onClick={addToCartApiCallForV2}
                >
                  <Image src={IC_UNION_WHITE} alt="UNION_LOGO" className="union-logo" />
                </div>
              )}
            </div>
          </div>
          <div className="produt-detail-wrapper">
            {showFillerTitle && (
              <div className="mini-cart-product-details">
                <div className={showEllipsisInTitle?'product-name-ellipsis':'product-name'}>{renderTitle(item?.item?.name)}</div>
                <div className="product-description">{item?.description}</div>
              </div>
            )}
            <div className="mini-cart-cost">
            {(item?.item?.specialPrice || item?.item?.special_price) ? (
                <>
                  <div className="price">AED {item?.item?.specialPrice || item?.item?.special_price}</div>
                  <div className="special-price">AED {item?.item?.price || item?.item?.price}</div>
                </>
              ) : (
                <div className="price">AED {item?.item?.price}</div>
              )}
            </div>
              {item?.isPromotionCart && (
                <div className="add-to-card">
                  <AddToCart
                    sku={sku}
                    minWidth="116px"
                    height="40px"
                    availableStock={item?.item?.quantity || item?.item?.availableStock}
                    product={item?.item}
                    isMyCartPage
                    outOfStock={!item?.item?.inStock}
                    setFilleraddedtocart={setFilleraddedtocart}
                    pageId={item?.pageId}
                    screenName={item?.screenName}
                    referrerpage={item?.referrerpage}
                    pageType={item?.pageType}
                    sectionName={item?.sectionName}
                    newButton={true}
                  />
                </div>
              )}
          </div>
        </div>
      </CartFillerMiniCartStyled>
    </>
  );
};

CartFillerMiniCart.propTypes = {
  productImage: PropTypes.string.isRequired,
  expressBadgeImage: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  productDescription: PropTypes.string.isRequired,
  productPrice: PropTypes.string.isRequired,
  isPromotionCart: PropTypes.bool,
  setShowUpselling: PropTypes.func,
  showUpselling: PropTypes.bool,
};
CartFillerMiniCart.defaultProps = {
  isPromotionCart: false,
  showUpselling: false,
  setShowUpselling: ()=>{},
};

export default CartFillerMiniCart;
